export default "/images/54ced40f39d328d4ca5e05640a043f16.png";